import { find } from 'lodash';

export default class AutoCategoryService {
    /* @ngInject */
    constructor($q, categoryService, monitoringCategorizationService) {
        this.$q = $q;
        this.categoryService = categoryService;
        this.monitoringCategorizationService = monitoringCategorizationService;

        this.reset();
    }

    reset() {
        this.map = {};
    }

    initialize(teamId, map) {
        this.map[teamId] = map || {};
    }

    get(teamId, note) {
        this.map[teamId] = this.map[teamId] || {};
        let categoryId = this.map[teamId][note];

        return categoryId
            ? this.$q.resolve(categoryId)
            : this.$q.reject();
    }

    guess(teamId, note) {
        return this.categoryService.getAll(teamId).then((categories) => {
            let teamCategories = this.buildTeamCategories(categories);
            let labelCategoryMap = this.buildLabelCategoryMap(teamId);

            return this.monitoringCategorizationService.categorizeLabel(note, teamCategories, labelCategoryMap).then((result) => {
                if (!result || typeof result.categoryId !== 'number') {
                    return this.$q.reject();
                }

                if (result.categoryId === -1) {
                    return this.$q.reject();
                }

                let category = find(categories || [], (item) => `${item.id}` === `${result.categoryId}`);

                return category ? category : this.$q.reject();
            });
        });
    }

    add(teamId, categoryId, note) {
        this.map[teamId] = this.map[teamId] || {};
        this.map[teamId][note] = categoryId;
    }

    remove(note) {
        delete this.map[note];
    }

    buildTeamCategories(categories) {
        return (categories || []).map((category) => {
            return {
                id: category.id,
                name: category.name,
                iconName: category.iconName || null,
                iconIndex: category.iconIndex || null,
                type: category.type || 'regular',
                color: category.color,
                isOther: !!category.other,
                weeklyLimit: category.weeklyLimit == null ? null : category.weeklyLimit,
                monthlyLimit: category.monthlyLimit == null ? null : category.monthlyLimit
            };
        });
    }

    buildLabelCategoryMap(teamId) {
        let map = this.map[teamId] || {};
        let grouped = {};

        Object.keys(map).forEach((label) => {
            let normalizedLabel = this.normalizeLabel(label);
            let categoryId = map[label];

            if (!normalizedLabel) {
                return;
            }

            if (categoryId == null) {
                return;
            }

            if (!grouped[categoryId]) {
                grouped[categoryId] = [];
            }

            if (!grouped[categoryId].includes(normalizedLabel)) {
                grouped[categoryId].push(normalizedLabel);
            }
        });

        return Object.keys(grouped).map((categoryId) => {
            return {
                categoryId: +categoryId,
                labels: grouped[categoryId]
            };
        });
    }

    normalizeLabel(label) {
        return String(label || '').trim().toLowerCase();
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/auto-category.service.js